import { EntityPresenterMode, isStaticMode } from './presenterEntityMode';

import type { Maybe } from '@nova/core';
import type { AppointmentDetails } from './appointmentPresenterShared';

export function nestedAppointmentPresenterDataProps(
  mode: EntityPresenterMode,
  data: { appointment?: Maybe<AppointmentDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticAppointmentData: data.appointment ?? null
    };
  }

  return {
    placeholderAppointmentData: data.appointment ?? null
  };
}
